module.exports = __webpack_public_path__ + "img/construction.30459869.svg";